import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import intersectMeshes from "./intersectMeshes";

const addBarrier = async (polotno, stolbik, kalitka, plot, { doorPosition, bez_kalitki, bez_prohoda, length_door, height_on_earth }) => {
    let sideA = new THREE.Group();
    let sideC = new THREE.Group();
    let sideD = new THREE.Group();
    let sideB = new THREE.Group();
    let finalGroup = new THREE.Group();
    const dopusk = 0.001;



    //добавляем 4 столбика
    const bboxStolbik = getPosInfo(stolbik);
    stolbik.position.set(
        plot.bbox.min.x + bboxStolbik.xSize / 2,
        bboxStolbik.ySize / 2,
        plot.bbox.min.z + bboxStolbik.zSize / 2
    );
    sideA.add(stolbik);
    const stolbik2 = stolbik.clone();
    stolbik2.position.set(
        plot.bbox.max.x - bboxStolbik.xSize / 2,
        bboxStolbik.ySize / 2,
        plot.bbox.min.z + bboxStolbik.zSize / 2
    );
    sideA.add(stolbik2);
    const stolbik3 = stolbik.clone();
    stolbik3.position.set(
        plot.bbox.min.x + bboxStolbik.xSize / 2,
        bboxStolbik.ySize / 2,
        plot.bbox.max.z - bboxStolbik.zSize / 2
    );
    sideA.add(stolbik3);
    const stolbik4 = stolbik.clone();
    stolbik4.position.set(
        plot.bbox.max.x - bboxStolbik.xSize / 2,
        bboxStolbik.ySize / 2,
        plot.bbox.max.z - bboxStolbik.zSize / 2
    );
    sideA.add(stolbik4);

    //полотно анфас
    const bboxPolotnoAnfas = getPosInfo(polotno);

    const heightOnEarth = +bboxPolotnoAnfas.ySize / 2 + +height_on_earth / 100;

    polotno.position.set(
        plot.bbox.min.x + bboxPolotnoAnfas.xSize / 2 + bboxStolbik.xSize,
        heightOnEarth,
        plot.bbox.min.z + bboxPolotnoAnfas.zSize / 2
    );

    const countInWidth = (plot.xSize - bboxStolbik.xSize * 2) / bboxPolotnoAnfas.xSize;
    const countInWidthInt = Math.trunc(countInWidth);
    const countInWidthFract = countInWidth - countInWidthInt;

    const sizeLastElementInSide = (plot.xSize - bboxStolbik.xSize * 2) - (bboxPolotnoAnfas.xSize * countInWidthInt);


    if ((doorPosition && doorPosition.side != 'a') || (bez_prohoda)) {
        if (countInWidthInt >= 1) {
            sideA.add(polotno);
            for (let index = 2; index <= countInWidthInt; index++) {
                const newPolotno = polotno.clone();
                newPolotno.position.x += (index - 1) * bboxPolotnoAnfas.xSize;
                sideA.add(newPolotno);
            }

            if (countInWidthFract) {
                const fractPolotno = polotno.clone();


                const scaleWidthFractPolotno = 1 - countInWidthFract;

                if (scaleWidthFractPolotno >= dopusk) {

                    //здесь обрезать дробный элемент
                    fractPolotno.position.x += countInWidthInt * bboxPolotnoAnfas.xSize;
                    fractPolotno.updateMatrix();

                    const bboxFractPolotno = getPosInfo(fractPolotno);

                    const cutMesh = new THREE.Mesh(
                        new THREE.BoxBufferGeometry(
                            sizeLastElementInSide, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                        ),
                        new THREE.MeshStandardMaterial()
                    )
                    cutMesh.position.copy(fractPolotno.position);
                    cutMesh.position.x = bboxFractPolotno.bbox.min.x + sizeLastElementInSide / 2
                    cutMesh.updateMatrix()

                    // sideA.add(cutMesh);

                    const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                    sideA.add(cutedFractPolotno);
                } else {
                    fractPolotno.position.x += countInWidthInt * bboxPolotnoAnfas.xSize;
                    sideA.add(fractPolotno);
                }

            }

        }

    }
    if ((doorPosition && doorPosition.side != 'c') || (bez_prohoda)) {
        const frontPolotno = polotno.clone();
        frontPolotno.position.z = plot.bbox.max.z - bboxPolotnoAnfas.zSize / 2;
        frontPolotno.updateMatrix();
        if (countInWidthInt >= 1) {
            sideC.add(frontPolotno);
            for (let index = 2; index <= countInWidthInt; index++) {
                const newPolotno = frontPolotno.clone();
                newPolotno.position.x += (index - 1) * bboxPolotnoAnfas.xSize;
                sideA.add(newPolotno);
            }
            if (countInWidthFract) {
                const fractPolotno = frontPolotno.clone();

                const scaleWidthFractPolotno = 1 - countInWidthFract;

                if (scaleWidthFractPolotno >= dopusk) {
                    //здесь обрезать дробный элемент
                    fractPolotno.position.x += countInWidthInt * bboxPolotnoAnfas.xSize;
                    fractPolotno.updateMatrix();

                    const bboxFractPolotno = getPosInfo(fractPolotno);

                    const cutMesh = new THREE.Mesh(
                        new THREE.BoxBufferGeometry(
                            sizeLastElementInSide, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                        ),
                        new THREE.MeshStandardMaterial()
                    )
                    cutMesh.position.copy(fractPolotno.position);
                    cutMesh.position.x = bboxFractPolotno.bbox.min.x + sizeLastElementInSide / 2
                    cutMesh.updateMatrix()

                    // sideA.add(cutMesh);

                    const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                    sideA.add(cutedFractPolotno);



                    // sideA.add(fractPolotno);

                } else {
                    fractPolotno.position.x += countInWidthInt * bboxPolotnoAnfas.xSize;
                    sideA.add(fractPolotno);
                }

            }
        }
    }

    //левая стенка
    const leftPolotno = polotno.clone();
    leftPolotno.rotation.y = -Math.PI / 2;
    leftPolotno.updateMatrix();

    const bboxPolotnoProfil = getPosInfo(leftPolotno);
    leftPolotno.position.set(
        plot.bbox.min.x + bboxPolotnoProfil.xSize / 2,
        heightOnEarth,
        plot.bbox.min.z + bboxPolotnoProfil.zSize / 2 + bboxStolbik.zSize
    );
    leftPolotno.updateMatrix();

    const countInLength = (plot.zSize - bboxStolbik.zSize * 2) / bboxPolotnoProfil.zSize;
    const countInLengthInt = Math.trunc(countInLength);
    const countInLengthFract = countInLength - countInLengthInt;
    const sizeLastElementInSideBok = (plot.zSize - bboxStolbik.zSize * 2) - (bboxPolotnoProfil.zSize * countInLengthInt);

    if ((doorPosition && doorPosition.side != 'd') || (bez_prohoda)) {
        if (countInLengthInt >= 1) {
            sideD.add(leftPolotno);
            for (let index = 2; index <= countInLengthInt; index++) {
                const newPolotno = leftPolotno.clone();
                newPolotno.position.z += (index - 1) * bboxPolotnoProfil.zSize;
                sideD.add(newPolotno);
            }
            if (countInLengthFract) {
                const fractPolotno = leftPolotno.clone();

                const scaleLengthFractPolotno = 1 - countInLengthFract;

                if (scaleLengthFractPolotno >= dopusk) {
                    //здесь обрезать дробный элемент
                    fractPolotno.position.z += countInLengthInt * bboxPolotnoProfil.zSize;

                    fractPolotno.updateMatrix();

                    const bboxFractPolotno = getPosInfo(fractPolotno);

                    const cutMesh = new THREE.Mesh(
                        new THREE.BoxBufferGeometry(
                            bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideBok
                        ),
                        new THREE.MeshStandardMaterial()
                    )
                    cutMesh.position.copy(fractPolotno.position);
                    cutMesh.position.z = bboxFractPolotno.bbox.min.z + sizeLastElementInSideBok / 2
                    cutMesh.updateMatrix()

                    // sideD.add(cutMesh);

                    const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                    sideD.add(cutedFractPolotno);


                    // sideD.add(fractPolotno);
                } else {
                    fractPolotno.position.z += countInLengthInt * bboxPolotnoProfil.zSize;
                    sideD.add(fractPolotno);
                }

            }
        }

    }

    if ((doorPosition && doorPosition.side != 'b') || (bez_prohoda)) {
        //правая стенка
        const rightPolotno = leftPolotno.clone();
        rightPolotno.position.x = plot.bbox.max.x - bboxPolotnoProfil.xSize / 2;
        rightPolotno.updateMatrix();
        if (countInLengthInt >= 1) {
            sideB.add(rightPolotno);
            for (let index = 2; index <= countInLengthInt; index++) {
                const newPolotno = rightPolotno.clone();
                newPolotno.position.z += (index - 1) * bboxPolotnoProfil.zSize;
                sideB.add(newPolotno);
            }
            if (countInLengthFract) {
                const fractPolotno = rightPolotno.clone();

                const scaleLengthFractPolotno = 1 - countInLengthFract;

                if (scaleLengthFractPolotno >= dopusk) {
                    //здесь обрезать дробный элемент
                    fractPolotno.position.z += countInLengthInt * bboxPolotnoProfil.zSize;
                    fractPolotno.updateMatrix();

                    const bboxFractPolotno = getPosInfo(fractPolotno);

                    const cutMesh = new THREE.Mesh(
                        new THREE.BoxBufferGeometry(
                            bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideBok
                        ),
                        new THREE.MeshStandardMaterial()
                    )
                    cutMesh.position.copy(fractPolotno.position);
                    cutMesh.position.z = bboxFractPolotno.bbox.min.z + sizeLastElementInSideBok / 2
                    cutMesh.updateMatrix()

                    // sideD.add(cutMesh);

                    const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                    sideD.add(cutedFractPolotno);


                    // sideD.add(fractPolotno);
                } else {
                    fractPolotno.position.z += countInLengthInt * bboxPolotnoProfil.zSize;
                    sideD.add(fractPolotno);
                }

            }
        }
    }

    //ставим проход
    if (doorPosition && doorPosition.side == 'c' && !bez_prohoda) {
        const stolbikKalitki1 = stolbik.clone();

        let countInWidthSideC = (plot.xSize - bboxStolbik.xSize * 3 - length_door / 100) / bboxPolotnoAnfas.xSize;
        let countInWidthIntSideC = Math.trunc(countInWidthSideC);
        let countInWidthFractSideC = countInWidthSideC - countInWidthIntSideC;
        let sizeLastElementInSideFas = (plot.xSize - bboxStolbik.xSize * 2 - length_door / 100) -
            (countInWidthIntSideC * bboxPolotnoAnfas.xSize)
        if (doorPosition.wherePlace == '' || doorPosition.wherePlace == 'placeRight') {
            stolbikKalitki1.position.set(
                plot.bbox.max.x - length_door / 100 - bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.max.z - bboxStolbik.zSize / 2
            );

            //заполнение полотном
            const frontPolotno = polotno.clone();
            frontPolotno.position.z = plot.bbox.max.z - bboxPolotnoAnfas.zSize / 2;
            frontPolotno.updateMatrix()
            if (countInWidthIntSideC >= 1) {
                sideC.add(frontPolotno);
                for (let index = 2; index <= countInWidthIntSideC; index++) {
                    const newPolotno = frontPolotno.clone();
                    newPolotno.position.x += (index - 1) * bboxPolotnoAnfas.xSize;
                    sideC.add(newPolotno);
                }
                if (countInWidthFractSideC) {
                    const fractPolotno = frontPolotno.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideC;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.x += countInWidthIntSideC * bboxPolotnoAnfas.xSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.min.x + sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideC.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideC.add(cutedFractPolotno);

                        // sideC.add(fractPolotno);
                    } else {
                        fractPolotno.position.x += countInWidthIntSideC * bboxPolotnoAnfas.xSize;
                        sideC.add(fractPolotno);
                    }

                }
            }
            //заполнение полотном конец

            //ставим калитку
            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out' || doorPosition.where == '') {
                    if (doorPosition.how == 'left' || doorPosition.how == '') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.max.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                } else {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.max.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                }


                sideC.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeLeft') {
            stolbikKalitki1.position.set(
                plot.bbox.min.x + length_door / 100 + bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.max.z - bboxStolbik.zSize / 2
            );

            //заполнение полотном


            const frontPolotno = polotno.clone();
            frontPolotno.position.z = plot.bbox.max.z - bboxPolotnoAnfas.zSize / 2;
            frontPolotno.position.x = stolbikKalitki1.position.x + bboxPolotnoAnfas.xSize / 2 + bboxStolbik.xSize / 2;

            frontPolotno.updateMatrix();

            if (countInWidthIntSideC >= 1) {
                sideC.add(frontPolotno);
                for (let index = 2; index <= countInWidthIntSideC; index++) {
                    const newPolotno = frontPolotno.clone();
                    newPolotno.position.x += (index - 1) * bboxPolotnoAnfas.xSize;
                    sideC.add(newPolotno);
                }
                if (countInWidthFractSideC) {
                    const fractPolotno = frontPolotno.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideC;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.x += countInWidthIntSideC * bboxPolotnoAnfas.xSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.min.x + sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideC.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideC.add(cutedFractPolotno);

                        // sideC.add(fractPolotno);
                    } else {
                        fractPolotno.position.x += countInWidthIntSideC * bboxPolotnoAnfas.xSize;
                        sideC.add(fractPolotno);
                    }

                }
            }
            //заполнение полотном конец


            if (!bez_kalitki) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.min.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }

                } else {

                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.min.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                }
                sideC.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeCenter') {
            const centerXPlot = 0;
            stolbikKalitki1.position.set(
                centerXPlot - length_door / 100 / 2 - bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.max.z - bboxStolbik.zSize / 2
            );
            const stolbikKalitki2 = stolbikKalitki1.clone();

            stolbikKalitki2.position.x += length_door / 100 + bboxStolbik.xSize / 2;

            sideC.add(stolbikKalitki2);

            //заполнение полотном нужно на две части по отдельности
            let countInWidthSideC =
                ((plot.xSize - bboxStolbik.xSize * 4 - length_door / 100) / 2) / bboxPolotnoAnfas.xSize;
            let countInWidthIntSideC = Math.trunc(countInWidthSideC);
            let countInWidthFractSideC = countInWidthSideC - countInWidthIntSideC;

            sizeLastElementInSideFas = ((plot.xSize - bboxStolbik.xSize * 2 - length_door / 100) / 2) - (countInWidthIntSideC * bboxPolotnoAnfas.xSize)

            const frontPolotno = polotno.clone();
            frontPolotno.position.z = plot.bbox.max.z - bboxPolotnoAnfas.zSize / 2;

            frontPolotno.updateMatrix();

            if (countInWidthIntSideC >= 1) {
                sideC.add(frontPolotno);
                for (let index = 2; index <= countInWidthIntSideC; index++) {
                    const newPolotno = frontPolotno.clone();
                    newPolotno.position.x += (index - 1) * bboxPolotnoAnfas.xSize;
                    sideC.add(newPolotno);
                }
                if (countInWidthFractSideC) {
                    const fractPolotno = frontPolotno.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideC;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.x += countInWidthIntSideC * bboxPolotnoAnfas.xSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.min.x + sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideC.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideC.add(cutedFractPolotno);

                        // sideC.add(fractPolotno);
                    } else {
                        fractPolotno.position.x += countInWidthIntSideC * bboxPolotnoAnfas.xSize;
                        sideC.add(fractPolotno);
                    }

                }
            } else {
                sideC.add(frontPolotno);
            }
            const newFrontPolotno = frontPolotno.clone();
            newFrontPolotno.position.x = plot.bbox.max.x - bboxPolotnoAnfas.xSize / 2 - bboxStolbik.xSize / 2;
            newFrontPolotno.updateMatrix();
            if (countInWidthIntSideC >= 1) {
                sideC.add(newFrontPolotno);
                for (let index = 2; index <= countInWidthIntSideC; index++) {
                    const newPolotno = newFrontPolotno.clone();
                    newPolotno.position.x -= (index - 1) * bboxPolotnoAnfas.xSize;
                    sideC.add(newPolotno);
                }
                if (countInWidthFractSideC) {
                    const fractPolotno = newFrontPolotno.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideC;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.x -= countInWidthIntSideC * bboxPolotnoAnfas.xSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas,
                                bboxPolotnoAnfas.ySize,
                                bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.max.x - sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideC.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideC.add(cutedFractPolotno);


                        // sideC.add(fractPolotno);
                    } else {
                        fractPolotno.position.x -= countInWidthIntSideC * bboxPolotnoAnfas.xSize;
                        sideC.add(fractPolotno);
                    }

                }
            } else {
                sideC.add(newFrontPolotno);
            }
            //заполнение полотном конец

            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }

                } else {

                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                }
                sideC.add(kalitka);
            }

        }

        sideC.add(stolbikKalitki1);
    }

    if (doorPosition && doorPosition.side == 'a' && !bez_prohoda) {
        const stolbikKalitki1 = stolbik.clone();

        let countInWidthSideA = (plot.xSize - bboxStolbik.xSize * 3 - length_door / 100) / bboxPolotnoAnfas.xSize;
        let countInWidthIntSideA = Math.trunc(countInWidthSideA);
        let countInWidthFractSideA = countInWidthSideA - countInWidthIntSideA;
        let sizeLastElementInSideFas = (plot.xSize - bboxStolbik.xSize * 1 - length_door / 100) - (bboxPolotnoAnfas.xSize * countInWidthIntSideA)

        if (doorPosition.wherePlace == '' || doorPosition.wherePlace == 'placeRight') {
            stolbikKalitki1.position.set(
                plot.bbox.min.x + length_door / 100 + bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.min.z + bboxStolbik.zSize / 2
            );

            //заполнение полотном
            const polotnoA = polotno.clone();
            polotnoA.position.set(plot.bbox.max.x - bboxPolotnoAnfas.xSize / 2,
                heightOnEarth,
                plot.bbox.min.z + bboxPolotnoAnfas.zSize / 2);

            polotnoA.updateMatrix();

            if (countInWidthIntSideA >= 1) {
                sideA.add(polotnoA);
                for (let index = 2; index <= countInWidthIntSideA; index++) {
                    const newPolotno = polotnoA.clone();
                    newPolotno.position.x -= (index - 1) * bboxPolotnoAnfas.xSize;
                    sideA.add(newPolotno);
                }
                if (countInWidthFractSideA) {
                    const fractPolotno = polotnoA.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideA;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.x -= countInWidthIntSideA * bboxPolotnoAnfas.xSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.max.x - sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideA.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideA.add(cutedFractPolotno);


                        // sideA.add(fractPolotno);
                    } else {
                        fractPolotno.position.x -= countInWidthIntSideA * bboxPolotnoAnfas.xSize;
                        sideA.add(fractPolotno);
                    }

                }
            }
            //заполнение полотном конец





            //ставим калитку
            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.min.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                } else {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.min.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                }


                sideC.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeLeft') {
            stolbikKalitki1.position.set(
                plot.bbox.max.x - length_door / 100 - bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.min.z + bboxStolbik.zSize / 2
            );

            //заполнение полотном
            const polotnoA = polotno.clone();
            polotnoA.position.set(plot.bbox.min.x + bboxPolotnoAnfas.xSize / 2,
                heightOnEarth,
                plot.bbox.min.z + bboxPolotnoAnfas.zSize / 2);

            polotnoA.updateMatrix();

            if (countInWidthIntSideA >= 1) {
                sideA.add(polotnoA);
                for (let index = 2; index <= countInWidthIntSideA; index++) {
                    const newPolotno = polotnoA.clone();
                    newPolotno.position.x += (index - 1) * bboxPolotnoAnfas.xSize;
                    sideA.add(newPolotno);
                }
                if (countInWidthFractSideA) {
                    const fractPolotno = polotnoA.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideA;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.x += countInWidthIntSideA * bboxPolotnoAnfas.xSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.min.x + sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideA.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideA.add(cutedFractPolotno);

                        // sideA.add(fractPolotno);
                    } else {
                        fractPolotno.position.x += countInWidthIntSideA * bboxPolotnoAnfas.xSize;
                        sideA.add(fractPolotno);
                    }

                }
            }
            //заполнение полотном конец

            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.max.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }

                } else {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            plot.bbox.max.x - bboxKalitka.xSize / 2 - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2 + bboxStolbik.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                }
                sideC.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeCenter') {

            const centerXPlot = 0;

            stolbikKalitki1.position.set(
                centerXPlot - length_door / 100 / 2 - bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.min.z + bboxStolbik.zSize / 2
            );

            const stolbikKalitki2 = stolbikKalitki1.clone();
            stolbikKalitki2.position.x += length_door / 100 + bboxStolbik.xSize / 2;
            sideA.add(stolbikKalitki2);


            //заполнение полотном нужно на две части по отдельности
            countInWidthSideA =
                ((plot.xSize - bboxStolbik.xSize * 4 - length_door / 100) / 2) / bboxPolotnoAnfas.xSize;
            countInWidthIntSideA = Math.trunc(countInWidthSideA);
            countInWidthFractSideA = countInWidthSideA - countInWidthIntSideA;

            sizeLastElementInSideFas = ((plot.xSize - bboxStolbik.xSize * 2 - length_door / 100) / 2) - (countInWidthIntSideA * bboxPolotnoAnfas.xSize)


            const PolotnoA = polotno.clone();
            PolotnoA.position.z = plot.bbox.min.z + bboxPolotnoAnfas.zSize / 2;

            PolotnoA.updateMatrix();

            if (countInWidthIntSideA >= 1) {
                sideA.add(PolotnoA);
                for (let index = 2; index <= countInWidthIntSideA; index++) {
                    const newPolotno = PolotnoA.clone();
                    newPolotno.position.x += (index - 1) * bboxPolotnoAnfas.xSize;
                    sideA.add(newPolotno);
                }
                if (countInWidthFractSideA) {
                    const fractPolotno = PolotnoA.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideA;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.x += countInWidthIntSideA * bboxPolotnoAnfas.xSize;
                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.min.x + sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideA.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideA.add(cutedFractPolotno);

                        // sideA.add(fractPolotno);
                    } else {
                        fractPolotno.position.x += countInWidthIntSideA * bboxPolotnoAnfas.xSize;
                        sideA.add(fractPolotno);
                    }

                }
            } else {
                //здесь дробный элемент
                sideA.add(PolotnoA);
            }
            const newPolotnoA = PolotnoA.clone();
            newPolotnoA.position.x = plot.bbox.max.x - bboxPolotnoAnfas.xSize / 2 - bboxStolbik.xSize;
            newPolotnoA.updateMatrix();

            if (countInWidthIntSideA >= 1) {
                sideA.add(newPolotnoA);
                for (let index = 2; index <= countInWidthIntSideA; index++) {
                    const newPolotno = newPolotnoA.clone();
                    newPolotno.position.x -= (index - 1) * bboxPolotnoAnfas.xSize;
                    sideA.add(newPolotno);
                }
                if (countInWidthFractSideA) {
                    const fractPolotno = newPolotnoA.clone();

                    const scaleWidthFractPolotno = 1 - countInWidthFractSideA;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.x -= countInWidthIntSideA * bboxPolotnoAnfas.xSize;
                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                sizeLastElementInSideFas, bboxPolotnoAnfas.ySize, bboxPolotnoAnfas.zSize
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);
                        cutMesh.position.x = bboxFractPolotno.bbox.max.x - sizeLastElementInSideFas / 2
                        cutMesh.updateMatrix()

                        // sideA.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideA.add(cutedFractPolotno);

                        // sideA.add(fractPolotno);
                    } else {
                        fractPolotno.position.x -= countInWidthIntSideA * bboxPolotnoAnfas.xSize;
                        sideA.add(fractPolotno);
                    }
                }
            } else {
                sideA.add(newPolotnoA);
            }
            //заполнение полотном конец


            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2
                        );
                    }

                } else {

                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = -Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot + bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            centerXPlot - bboxStolbik.xSize,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2
                        );
                    }
                }
                sideC.add(kalitka);
            }
        }

        sideA.add(stolbikKalitki1);
    }
    if (doorPosition && doorPosition.side == 'd') {
        const stolbikKalitki1 = stolbik.clone();

        let countInLengthSideD = (plot.zSize - bboxStolbik.zSize * 3 - length_door / 100) / bboxPolotnoProfil.zSize;
        let countInLengthIntSideD = Math.trunc(countInLengthSideD);
        let countInLengthFractSideD = countInLengthSideD - countInLengthIntSideD;
        let sizeLastElementInSideProfil = (plot.zSize - bboxStolbik.zSize - length_door / 100) - (countInLengthIntSideD * bboxPolotnoProfil.zSize)

        if (doorPosition.wherePlace == '' || doorPosition.wherePlace == 'placeRight') {
            stolbikKalitki1.position.set(
                plot.bbox.min.x + bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.max.z - length_door / 100 - bboxStolbik.zSize / 2
            );

            //заполнение полотном
            const polotnoD = polotno.clone();

            polotnoD.rotation.y = -Math.PI / 2;

            polotnoD.position.set(plot.bbox.min.x + bboxPolotnoProfil.xSize / 2,
                0,
                plot.bbox.min.z + bboxPolotnoProfil.zSize / 2);
            polotnoD.updateMatrix();

            if (countInLengthSideD >= 1) {
                sideD.add(polotnoD);
                for (let index = 2; index <= countInLengthSideD; index++) {
                    const newPolotno = polotnoD.clone();
                    newPolotno.position.z += (index - 1) * bboxPolotnoProfil.zSize;
                    sideD.add(newPolotno);
                }
                if (countInLengthFractSideD) {
                    const fractPolotno = polotnoD.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideD;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.z += countInLengthIntSideD * bboxPolotnoProfil.zSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.min.z + sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideD.add(cutedFractPolotno);

                        // sideD.add(fractPolotno);
                    } else {
                        fractPolotno.position.z += countInLengthIntSideD * bboxPolotnoProfil.zSize;
                        sideD.add(fractPolotno);
                    }

                }
            }
            //заполнение полотном конец

            //ставим калитку
            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2 + bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            plot.bbox.max.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize
                        );
                    }
                } else {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2 + bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            plot.bbox.max.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize
                        );
                    }
                }
                sideD.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeLeft') {
            stolbikKalitki1.position.set(
                plot.bbox.min.x + bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.min.z + length_door / 100 + bboxStolbik.zSize / 2
            );

            //заполнение полотном
            const polotnoD = polotno.clone();
            polotnoD.rotation.y = -Math.PI / 2;
            polotnoD.position.set(plot.bbox.min.x + bboxPolotnoProfil.xSize / 2,
                heightOnEarth,
                stolbikKalitki1.position.z + bboxPolotnoProfil.zSize / 2 + bboxStolbik.zSize / 2);

            if (countInLengthSideD >= 1) {
                sideD.add(polotnoD);
                for (let index = 2; index <= countInLengthSideD; index++) {
                    const newPolotno = polotnoD.clone();
                    newPolotno.position.z += (index - 1) * bboxPolotnoProfil.zSize;
                    sideD.add(newPolotno);
                }
                if (countInLengthFractSideD) {
                    const fractPolotno = polotnoD.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideD;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.z += countInLengthIntSideD * bboxPolotnoProfil.zSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.min.z + sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideD.add(cutedFractPolotno);

                        // sideD.add(fractPolotno);
                    } else {
                        fractPolotno.position.z += countInLengthIntSideD * bboxPolotnoProfil.zSize;
                        sideD.add(fractPolotno);
                    }
                }
            }
            //заполнение полотном конец

            //ставим калитку
            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            plot.bbox.min.z + bboxKalitka.zSize / 2 + bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize
                        );
                    }
                } else {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            plot.bbox.min.z + bboxKalitka.zSize / 2 + bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize
                        );
                    }
                }


                sideD.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeCenter') {
            const centerZPlot = 0;
            stolbikKalitki1.position.set(
                plot.bbox.min.x + bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                centerZPlot - length_door / 100 / 2 - bboxStolbik.zSize / 2,
            );
            const stolbikKalitki2 = stolbikKalitki1.clone();
            stolbikKalitki2.position.z += length_door / 100 + bboxStolbik.zSize / 2;
            sideD.add(stolbikKalitki2);


            //заполнение полотном
            countInLengthSideD = (plot.zSize - bboxStolbik.zSize * 4 - length_door / 100) / 2 / bboxPolotnoAnfas.xSize;
            countInLengthIntSideD = Math.trunc(countInLengthSideD);
            countInLengthFractSideD = countInLengthSideD - countInLengthIntSideD;
            sizeLastElementInSideProfil = ((plot.zSize - bboxStolbik.zSize * 2 - length_door / 100) / 2) - (countInLengthIntSideD * bboxPolotnoAnfas.xSize)

            const polotnoD = polotno.clone();

            polotnoD.rotation.y = -Math.PI / 2;

            polotnoD.position.set(plot.bbox.min.x + bboxPolotnoProfil.xSize / 2,
                heightOnEarth,
                plot.bbox.min.z + bboxPolotnoProfil.zSize / 2 + bboxStolbik.zSize / 2);

            polotnoD.updateMatrix();

            if (countInLengthSideD >= 1) {
                sideD.add(polotnoD);
                for (let index = 2; index <= countInLengthSideD; index++) {
                    const newPolotno = polotnoD.clone();
                    newPolotno.position.z += (index - 1) * bboxPolotnoProfil.zSize;
                    sideD.add(newPolotno);
                }
                if (countInLengthFractSideD) {
                    const fractPolotno = polotnoD.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideD;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент
                        fractPolotno.position.z += countInLengthIntSideD * bboxPolotnoProfil.zSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.min.z + sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideD.add(cutedFractPolotno);


                        // sideD.add(fractPolotno);
                    } else {
                        fractPolotno.position.z += countInLengthIntSideD * bboxPolotnoProfil.zSize;
                        sideD.add(fractPolotno);
                    }
                }
            } else {
                //здесь обрезать дробный элемент
                sideD.add(polotnoD);
            }
            const polotnoD2 = polotno.clone();

            polotnoD2.rotation.y = -Math.PI / 2;

            polotnoD2.position.set(plot.bbox.min.x + bboxPolotnoProfil.xSize / 2,
                heightOnEarth,
                plot.bbox.max.z - bboxPolotnoProfil.zSize / 2 - bboxStolbik.zSize / 2);

            polotnoD2.updateMatrix();

            if (countInLengthSideD >= 1) {
                sideD.add(polotnoD2);
                for (let index = 2; index <= countInLengthSideD; index++) {
                    const newPolotno = polotnoD2.clone();
                    newPolotno.position.z -= (index - 1) * bboxPolotnoProfil.zSize;
                    sideD.add(newPolotno);
                }
                if (countInLengthFractSideD) {
                    const fractPolotno = polotnoD2.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideD;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.z -= countInLengthIntSideD * bboxPolotnoProfil.zSize;
                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.max.z - sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideD.add(cutedFractPolotno);

                        // sideD.add(fractPolotno);
                    } else {
                        fractPolotno.position.z -= countInLengthIntSideD * bboxPolotnoProfil.zSize;
                        sideD.add(fractPolotno);
                    }
                }
            } else {
                //здесь обрезать дробный элемент
                sideD.add(polotnoD2);
            }
            //заполнение полотном конец


            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            centerZPlot - bboxStolbik.zSize,
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki2.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize,
                        );
                    }

                } else {

                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            centerZPlot - bboxStolbik.zSize,
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki2.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize,
                        );
                    }
                }
                sideD.add(kalitka);
            }
        }
        sideD.add(stolbikKalitki1);
    }
    if (doorPosition && doorPosition.side == 'b') {
        const stolbikKalitki1 = stolbik.clone();

        let countInLengthSideB = (plot.zSize - bboxStolbik.zSize * 3 - length_door / 100) / bboxPolotnoProfil.zSize;
        let countInLengthIntSideB = Math.trunc(countInLengthSideB);
        let countInLengthFractSideB = countInLengthSideB - countInLengthIntSideB;
        let sizeLastElementInSideProfil = (plot.zSize - bboxStolbik.zSize * 2 - length_door / 100) - (countInLengthIntSideB * bboxPolotnoProfil.zSize)

        if (doorPosition.wherePlace == '' || doorPosition.wherePlace == 'placeRight') {
            stolbikKalitki1.position.set(
                plot.bbox.max.x - bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.min.z + length_door / 100 + bboxStolbik.zSize / 2
            );

            //заполнение полотном
            const polotnoB = polotno.clone();
            polotnoB.rotation.y = Math.PI / 2;
            polotnoB.position.set(plot.bbox.max.x - bboxPolotnoProfil.xSize / 2,
                heightOnEarth,
                stolbikKalitki1.position.z + bboxPolotnoProfil.zSize / 2 + bboxStolbik.zSize / 2);

            if (countInLengthSideB >= 1) {
                sideB.add(polotnoB);
                for (let index = 2; index <= countInLengthSideB; index++) {
                    const newPolotno = polotnoB.clone();
                    newPolotno.position.z += (index - 1) * bboxPolotnoProfil.zSize;
                    sideB.add(newPolotno);
                }
                if (countInLengthFractSideB) {
                    const fractPolotno = polotnoB.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideB;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.z += countInLengthIntSideB * bboxPolotnoProfil.zSize;

                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.min.z + sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideB.add(cutedFractPolotno);

                        // sideB.add(fractPolotno);
                    } else {
                        fractPolotno.position.z += countInLengthIntSideB * bboxPolotnoProfil.zSize;
                        sideB.add(fractPolotno);
                    }

                }
            }
            //заполнение полотном конец

            //ставим калитку
            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize
                        );
                    }
                } else {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize
                        );
                    }
                }


                sideD.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeLeft') {
            stolbikKalitki1.position.set(
                plot.bbox.max.x - bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                plot.bbox.max.z - length_door / 100 - bboxStolbik.zSize / 2
            );

            //заполнение полотном
            const polotnoB = polotno.clone();
            polotnoB.rotation.y = Math.PI / 2;
            polotnoB.position.set(plot.bbox.max.x - bboxPolotnoProfil.xSize / 2,
                heightOnEarth,
                stolbikKalitki1.position.z - bboxPolotnoProfil.zSize / 2 - bboxStolbik.zSize / 2);

            if (countInLengthSideB >= 1) {
                sideB.add(polotnoB);
                for (let index = 2; index <= countInLengthSideB; index++) {
                    const newPolotno = polotnoB.clone();
                    newPolotno.position.z -= (index - 1) * bboxPolotnoProfil.zSize;
                    sideB.add(newPolotno);
                }
                if (countInLengthFractSideB) {
                    const fractPolotno = polotnoB.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideB;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.z -= countInLengthIntSideB * bboxPolotnoProfil.zSize;
                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.max.z - sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideB.add(cutedFractPolotno);

                        // sideB.add(fractPolotno);
                    } else {
                        fractPolotno.position.z -= countInLengthIntSideB * bboxPolotnoProfil.zSize;
                        sideB.add(fractPolotno);
                    }

                }
            }
            //заполнение полотном конец

            //ставим калитку
            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            plot.bbox.max.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            plot.bbox.max.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize
                        );
                    }
                } else {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            plot.bbox.max.z - bboxKalitka.zSize / 2 - bboxStolbik.zSize / 2
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            stolbikKalitki1.position.z + bboxKalitka.zSize / 2 + bboxStolbik.zSize
                        );
                    }
                }
                sideD.add(kalitka);
            }
        }
        if (doorPosition.wherePlace == 'placeCenter') {
            const centerZPlot = 0;
            stolbikKalitki1.position.set(
                plot.bbox.max.x - bboxStolbik.xSize / 2,
                bboxStolbik.ySize / 2,
                centerZPlot - length_door / 100 / 2 - bboxStolbik.zSize / 2,
            );
            const stolbikKalitki2 = stolbikKalitki1.clone();
            stolbikKalitki2.position.z += length_door / 100 + bboxStolbik.zSize / 2;
            sideB.add(stolbikKalitki2);


            //заполнение полотном
            countInLengthSideB = (plot.zSize - bboxStolbik.zSize * 4 - length_door / 100) / 2 / bboxPolotnoProfil.zSize;
            countInLengthIntSideB = Math.trunc(countInLengthSideB);
            countInLengthFractSideB = countInLengthSideB - countInLengthIntSideB;
            sizeLastElementInSideProfil = ((plot.zSize - bboxStolbik.zSize * 2 - length_door / 100) / 2) - (countInLengthIntSideB * bboxPolotnoProfil.zSize)

            const polotnoB = polotno.clone();

            polotnoB.rotation.y = Math.PI / 2;

            polotnoB.position.set(plot.bbox.max.x - bboxPolotnoProfil.xSize / 2,
                heightOnEarth,
                plot.bbox.min.z + bboxPolotnoProfil.zSize / 2 + bboxStolbik.zSize / 2);

            if (countInLengthSideB >= 1) {
                sideB.add(polotnoB);
                for (let index = 2; index <= countInLengthSideB; index++) {
                    const newPolotno = polotnoB.clone();
                    newPolotno.position.z += (index - 1) * bboxPolotnoProfil.zSize;
                    sideB.add(newPolotno);
                }
                if (countInLengthFractSideB) {
                    const fractPolotno = polotnoB.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideB;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.z += countInLengthIntSideB * bboxPolotnoProfil.zSize;
                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.min.z + sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideB.add(cutedFractPolotno);

                        // sideB.add(fractPolotno);
                    } else {
                        fractPolotno.position.z += countInLengthIntSideB * bboxPolotnoProfil.zSize;
                        sideB.add(fractPolotno);
                    }
                }
            } else {
                //здесь обрезать дробный элемент
                sideB.add(polotnoB);
            }
            const polotnoB2 = polotno.clone();

            polotnoB2.rotation.y = Math.PI / 2;

            polotnoB2.position.set(plot.bbox.max.x - bboxPolotnoProfil.xSize / 2,
                heightOnEarth,
                plot.bbox.max.z - bboxPolotnoProfil.zSize / 2 - bboxStolbik.zSize / 2);

            if (countInLengthSideB >= 1) {
                sideB.add(polotnoB2);
                for (let index = 2; index <= countInLengthSideB; index++) {
                    const newPolotno = polotnoB2.clone();
                    newPolotno.position.z -= (index - 1) * bboxPolotnoProfil.zSize;
                    sideB.add(newPolotno);
                }
                if (countInLengthFractSideB) {
                    const fractPolotno = polotnoB2.clone();

                    const scaleWidthFractPolotno = 1 - countInLengthFractSideB;

                    if (scaleWidthFractPolotno >= dopusk) {
                        //здесь обрезать дробный элемент

                        fractPolotno.position.z -= countInLengthIntSideB * bboxPolotnoProfil.zSize;
                        fractPolotno.updateMatrix();

                        const bboxFractPolotno = getPosInfo(fractPolotno);

                        const cutMesh = new THREE.Mesh(
                            new THREE.BoxBufferGeometry(
                                bboxPolotnoProfil.xSize, bboxPolotnoProfil.ySize, sizeLastElementInSideProfil
                            ),
                            new THREE.MeshStandardMaterial()
                        )
                        cutMesh.position.copy(fractPolotno.position);

                        cutMesh.position.z = bboxFractPolotno.bbox.max.z - sizeLastElementInSideProfil / 2

                        cutMesh.updateMatrix()

                        // sideD.add(cutMesh);

                        const cutedFractPolotno = await intersectMeshes(fractPolotno, cutMesh, true)
                        sideB.add(cutedFractPolotno);
                        // sideB.add(fractPolotno);
                    } else {
                        fractPolotno.position.z -= countInLengthIntSideB * bboxPolotnoProfil.zSize;
                        sideB.add(fractPolotno);
                    }
                }
            } else {
                //здесь обрезать дробный элемент
                sideB.add(polotnoB2);
            }
            //заполнение полотном конец


            if (!bez_kalitki && !bez_prohoda) {
                if (doorPosition.where == 'out') {
                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            centerZPlot + bboxStolbik.zSize,
                        );
                    }
                    if (doorPosition.how == 'right') {

                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25

                        const bboxKalitka = getPosInfo(kalitka);

                        kalitka.position.set(
                            stolbikKalitki1.position.x + bboxKalitka.xSize / 2,
                            heightOnEarth,
                            centerZPlot - bboxStolbik.zSize,
                        );
                    }

                } else {

                    if (doorPosition.how == 'left') {
                        kalitka.rotation.y = Math.PI / 2 - Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            centerZPlot + bboxStolbik.zSize,
                        );
                    }
                    if (doorPosition.how == 'right') {
                        kalitka.rotation.y = Math.PI / 2 + Math.PI / 1.25
                        const bboxKalitka = getPosInfo(kalitka);
                        kalitka.position.set(
                            stolbikKalitki1.position.x - bboxKalitka.xSize / 2,
                            heightOnEarth,
                            centerZPlot - bboxStolbik.zSize,
                        );
                    }
                }
                sideB.add(kalitka);
            }
        }
        sideB.add(stolbikKalitki1);
    }

    finalGroup.add(sideA);
    finalGroup.add(sideC);
    finalGroup.add(sideD);
    finalGroup.add(sideB);

    return finalGroup;
}
export default addBarrier;
